import React, { useState, useEffect } from 'react';
import { Typography, Space, Button, Table, Input, Image, Tag, Popconfirm } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import IndividualTraderService from '../../services/IndividualTraderService';
import WorkflowAccOpeningService from '../../services/WorkflowAccOpeningService';

const { Title } = Typography;

export default function IndividualAccOpening() {
  const location = useLocation();
  const [applicationList, setApplicationList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { user, showNotification } = useAuth();
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [clickedId, setClickedId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  // Read application list
  const loadData = async () => {
    const searchParams = new URLSearchParams(location.search);
    const pageParam = searchParams.get('page') || 1;
    const sizeParam = searchParams.get('size') || 10;
    setPage(Number(pageParam) || 1);
    setSize(Number(sizeParam) || 10);
    setLoading(true);
    console.log(user.role, getTradingStageByRole(user.role));
    const response = await WorkflowAccOpeningService.getIndividualAccList({
      // WorkflowStage: 'PREPARING',
      name: searchText,
      page: pageParam,
      size: sizeParam,
    });
    console.log(response.traderList);

    if (response.success === true) {
      setApplicationList(
        response.traderList.map(data => ({
          ...data,
          key: data.tradingAccountNo,
        })),
      );
      setTotalCount(response.totalCount);
    } else {
      showNotification('error', response.message);
    }
    setLoading(false);
  };

  const getTradingStageByRole = role => {
    if (role == 'ADMIN') {
      return ['PREPARING', 'SUBMITTED'];
    } else if (role == 'CHECKER') {
      return ['SUBMITTED'];
    } else if (role == 'MAKER') {
      return ['PREPARING', 'SUBMITTED'];
    }
  };

  useEffect(() => {
    loadData();
  }, [location.search, searchText]);

  const [filter, setFilter] = useState('');

  const handleTableChange = (pagination, filters, sorter) => {
    // Update the filter value in the filters object
    const updatedFilters = { ...filters, tradingAccountNo: [filter] };

    // Access the updated filters and other parameters here
    console.log('Filters:', updatedFilters);
    navigate(`/?page=${pagination.current}&size=${pagination.pageSize}`);

    // Other handling logic
  };
  const handleDelete = async traderId => {
    setConfirmLoading(true);
    const response = await WorkflowAccOpeningService.deleteAcc({
      workflowId: traderId,
    });
    setOpenDelete(false);
    setClickedId(null);
    setConfirmLoading(false);
    if (response.success) {
      showNotification('success', 'Deleted');
      setApplicationList(applicationList.filter(trader => trader.traderId !== traderId))
    } else {
      showNotification('error', response.message);
    }
    console.log(response);
  };

  const handleCancel = () => {
    setOpenDelete(false);
    setClickedId(null);
  };

  const showPopconfirm = (id, type) => {
    setClickedId(id);
    setOpenDelete(true);
  };

  // Table columns
  const tableColumns = [
    {
      title: 'Trading Account No.',
      dataIndex: 'tradingAccountNo',
      key: 'tradingAccountNo',
    },
    {
      title: 'Application No.',
      dataIndex: 'applicationNo',
      key: 'applicationNo',
    },

    {
      title: 'Full Name',
      dataIndex: ['firstName', 'middleName', 'lastName'],
      key: 'fullName',
      render: (text, record) => `${record.firstName} ${record.middleName} ${record.lastName}`,
    },
    {
      title: 'Client Type',
      dataIndex: 'clientType',
      key: 'clientType',
    },
    {
      title: 'Primary Email',
      dataIndex: 'primaryEmail',
      key: 'primaryEmail',
    },
    {
      title: 'Identity No.',
      dataIndex: 'identityValue',
      key: 'identityValue',
    },
    {
      title: 'Identity Type',
      dataIndex: 'identityType',
      key: 'identityType',
    },
    {
      title: 'Stage',
      dataIndex: 'stage',
      key: 'stage',
      render: (text, record) => {
        switch (record.stage) {
          case 'MIGRATING':
            return (
              <Tag color="#E7E6C6" style={{ borderRadius: '20px' }}>
                {text}
              </Tag>
            );
          case 'PREPARING':
            return (
              <Tag color="#503FB3" style={{ borderRadius: '20px' }}>
                {text}
              </Tag>
            );
          case 'SUBMITTED':
            return (
              <Tag color="#B33FA2" style={{ borderRadius: '20px' }}>
                {text}
              </Tag>
            );
          case 'APPROVED':
            return (
              <Tag color="#3FB350" style={{ borderRadius: '20px' }}>
                {text}
              </Tag>
            );
          case 'REJECTED':
            return (
              <Tag color="#D85C5C" style={{ borderRadius: '20px' }}>
                {text}
              </Tag>
            );
          default:
            break;
        }
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space align='center' >
        
          <Button
            icon={<Image src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} preview={false} />}
            type={'link'}
            onClick={() => navigate(`/individual/fill/${record.traderId}`)}
          ></Button>
          <Popconfirm
            title={record.traderId}
            description="Are you sure to delete this trader opening?"
            open={clickedId === record.traderId && openDelete}
            onConfirm={() => handleDelete(record.traderId)}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
            
          >
            <Button size={'small'} danger onClick={() => showPopconfirm(record.traderId)} 
              style={
                record.stage !== 'APPROVED'
                  ? {}
                  : { display: 'none' }
              }
            >
              Delete
            </Button>
          </Popconfirm>
          {/* <Button onClick={() => handleApprove(record.traderId)}>Approve</Button> */}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Space
        direction="horizontal"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Individual Account Opening - Submission
        </Title>
        {user.role == 'ADMIN' || user.role == 'MAKER' ? (
          <Button
            type="primary"
            size={'middle'}
            // icon={<PlusCircleOutlined />}
            onClick={() => navigate('/individual/prepare')}
          >
            Create
          </Button>
        ) : null}
      </Space>

      <Space.Compact style={{ float: 'right', marginBottom: '1rem' }}>
        <Input
          addonAfter={<SearchOutlined />}
          placeholder="Search"
          size={'middle'}
          allowClear
          onChange={e => setSearchText(e.target.value)}
        />
      </Space.Compact>

      <Table
        columns={tableColumns}
        dataSource={applicationList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        bordered
        pagination={{
          current: page,
          pageSize: size,
          total: totalCount,
        }}
        onChange={handleTableChange}
        loading={loading}
      />
    </>
  );
}
